import { render, staticRenderFns } from "./patient_diagnose_new.vue?vue&type=template&id=8e7029fe&scoped=true&"
import script from "./patient_diagnose_new.vue?vue&type=script&lang=js&"
export * from "./patient_diagnose_new.vue?vue&type=script&lang=js&"
import style0 from "./patient_diagnose_new.vue?vue&type=style&index=0&id=8e7029fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7029fe",
  null
  
)

component.options.__file = "patient_diagnose_new.vue"
export default component.exports